import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import LanguageSwitch from './components/LanguageSwitch';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import CadastroPage from './components/CadastroPage';
import BuscaCertificadoPage from './components/BuscaCertificadoPage';
import MeusCadastrosPage from './components/MeusCadastrosPage';
import CadastroAplicadorPage from './components/CadastroAplicadorPage';
import EsqueciSenhaPage from './components/EsqueciSenhaPage';
import RedefinirSenhaPage from './components/RedefinirSenhaPage';

function AppContent() {
  const location = useLocation();
  const showLanguageSwitch = location.pathname === '/';

  return (
    <div className="App">
      {showLanguageSwitch && <LanguageSwitch />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<CadastroPage />} />
        <Route path="/buscar-certificado" element={<BuscaCertificadoPage />} />
        <Route path="/meus-cadastros" element={<MeusCadastrosPage />} />
        <Route path="/cadastro-aplicador" element={<CadastroAplicadorPage />} />
        <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />
        <Route path="/redefinir-senha/:token" element={<RedefinirSenhaPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
    <Router>
      <AppContent />
    </Router>
    </LanguageProvider>
  );
}

export default App;
